import {fadeIn, fadeOut} from "./utilities/fade";

function buildChildrenBackLink(wrapper) {
    const childrenBackLink = document.createElement("a");
    const li = document.createElement("li");
    childrenBackLink.classList.add("mobileMenu__backLink");
    childrenBackLink.innerText = GLOBALS.tc.back;
    childrenBackLink.href = "#";
    li.appendChild(childrenBackLink);

    childrenBackLink.addEventListener("click", function (e) {
        e.preventDefault();
        childrenBackLink.closest(".hasChildren.is-open").classList.remove("is-open");
        const closestUl = childrenBackLink.closest(".hasChildren.is-open").querySelector("ul");
        if(closestUl){
            closestUl.scrollTop = 0;
            closestUl.style.overflow = "";
        }
    });

    wrapper.prepend(li);
}

function buildChildrenHeader(wrapper, childrenLink) {
    const childrenHeader = document.createElement("a");
    const li = document.createElement("li");
    li.appendChild(childrenHeader);

    childrenHeader.classList.add("mobileMenu__subHeader");
    childrenHeader.innerText = childrenLink.innerText;
    if (childrenLink.tagName === 'A') {
        childrenHeader.href = childrenLink.href;
    }

    wrapper.prepend(li);
}

function addClickEventMobileMenuLink(link) {
    let hasChildren = false;
    let childrenLink = false;
    let parent = link.closest("li");
    let childrenList = false;

    for (let children of parent.children) {
        if (children.tagName === "UL") {
            hasChildren = true;
            childrenList = children;
        }
        if (children.tagName === 'A' || children.tagName === 'SPAN') {
            childrenLink = children;
        }
    }

    if (hasChildren) {
        childrenLink.addEventListener("click", function (e) {
            let closestLi = childrenLink.closest('li');
            let closestUl = childrenLink.closest("ul");
            closestUl.scrollTop = 0;
            if (closestLi.classList.contains("is-open")) {
                closestLi.classList.remove("is-open");
                childrenLink.classList.remove("is-active");
                closestUl.style.overflow = "";
            } else {
                closestLi.classList.add("is-open");
                childrenLink.classList.add("is-active");
                closestUl.style.overflow = "hidden";
            }
            e.preventDefault();
        });

        parent.classList.add("hasChildren");

        if (childrenList) {
            buildChildrenHeader(childrenList, childrenLink);
            buildChildrenBackLink(childrenList);
        }
    }
}

// Utility: Set or remove tabindex="-1" on all focusable elements inside the menu
function setFocusableElements(menu, enable) {
    // Common focusable selectors (links, buttons, inputs, selects, textareas, elements with tabindex >= 0)
    const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ];

    const focusableElements = menu.querySelectorAll(focusableSelectors.join(','));

    focusableElements.forEach(el => {
        if (enable) {
            // Remove tabindex to restore natural focus
            el.removeAttribute('tabindex');
        } else {
            // Disable focus by setting tabindex -1
            el.setAttribute('tabindex', '-1');
        }
    });
}

export function buildMobileMenu(menu) {
    if (menu) {
        for(let menuNavigation of menu.querySelectorAll(".mobileMenu__navigation")){
            for (let link of menuNavigation.querySelectorAll('a')) {
                addClickEventMobileMenuLink(link);
            }
            for (let activeUl of menuNavigation.querySelectorAll('.is-active,.is-active-tree')) {
                activeUl.classList.add("is-open");
            }
        }

        // Initially hide the menu from screen readers and disable focusable elements
        menu.setAttribute('aria-hidden', 'true');
        setFocusableElements(menu, false);
    }
}

export function showMobileMenu(menu, overlay, toggle) {
    fadeIn(overlay, 200, "linear", function () {
        menu.classList.add("is-open");
        toggle.classList.add("is-active");
        toggle.setAttribute('aria-expanded', 'true');

        document.body.classList.add("is-mobilemenuopen");

        // Make menu visible to screen readers
        menu.removeAttribute('aria-hidden');
        // Enable keyboard focus inside menu
        setFocusableElements(menu, true);

        // Optionally, set focus to first focusable element inside menu for accessibility
        const firstFocusable = menu.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
    });
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("is-open");
    toggle.classList.remove("is-active");
    toggle.setAttribute('aria-expanded', 'false');

    document.body.classList.remove("is-mobilemenuopen");
    fadeOut(overlay);

    // Hide menu from screen readers
    menu.setAttribute('aria-hidden', 'true');
    // Disable keyboard focus inside menu
    setFocusableElements(menu, false);

    // Optionally, move focus back to toggle button after closing menu
    toggle.focus();
}
